<template>
  <!-- ADD TO TEXT FIELD: append-outer-icon="mdi-google-translate" -->
  <div class="box">
    <v-form ref="form">
      <v-row justify="center">
        <v-col align="center" cols="6">
          <v-text-field
            outlined
            dense
            label="Nombre"
            v-model="input.name"
            readonly
          ></v-text-field>
        </v-col>
        <v-col align="center" cols="6">
          <div class="d-flex">
            <div class="flag">
              <flag iso="es" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.name.es"
              @click:append-outer="translate(input.trans.name.es, 'es')"
            ></v-text-field>
          </div>
          <div class="d-flex">
            <div class="flag">
              <flag iso="it" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.name.it"
              @click:append-outer="translate(input.trans.name.it, 'it')"
            ></v-text-field>
          </div>
          <div class="d-flex">
            <div class="flag">
              <flag iso="gb" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.name.en"
              @click:append-outer="translate(input.trans.name.en, 'en')"
            ></v-text-field>
          </div>
          <div class="d-flex">
            <div class="flag">
              <flag iso="fr" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.name.fr"
              @click:append-outer="translate(input.trans.name.fr, 'fr')"
            ></v-text-field>
          </div>
          <div class="d-flex">
            <div class="flag">
              <flag iso="de" />
            </div>
            <v-text-field
              outlined
              dense
              v-model="input.trans.name.de"
              @click:append-outer="translate(input.trans.name.de, 'de')"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col align="center">
          <v-btn @click.prevent="saveTranslations(input)" class="save-btn"
            >Guardar</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
export default {
  name: "Translate",
  props: ["data"],
  data() {
    return {
      input: {
        trans: {
          name: {
            es: this.data.trans ? this.data.trans.name.es : this.data.name,
            fr: this.data.trans ? this.data.trans.name.fr : this.data.name,
            en: this.data.trans ? this.data.trans.name.en : this.data.name,
            it: this.data.trans ? this.data.trans.name.it : this.data.name,
            de: this.data.trans ? this.data.trans.name.de : this.data.name
          }
        },
        ...this.data
      }
    };
  },
  methods: {
    saveTranslations(input) {
      this.$emit("saveToCollection", input);
    },
    translate(name, language) {
      console.log("SPANISH", name);
      console.log("language", language);
    }
  }
};
</script>
